export const PAGE_EVENTS_COMPARE_DOMAINS = ['programeregionale.eu/lp2'];
